module.exports = __webpack_public_path__ + "static/media/Test26.91f835c7.bmp";